module.exports = __webpack_public_path__ + "img/my_build_edit-skills-selected@2x.bbb335ad.jpg";